import { useState } from "react";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import PropTypes from "prop-types";
import style from "./Form.module.scss";

function Terms({ handleSubmit }) {
  const [terms, setTerms] = useState({
    t1: false,
    t2: false,
  });

  /**
   *
   * @param {*} event
   */
  function onChangeTerms(event) {
    let newTerms = Object.assign({}, terms);
    newTerms[event.target.name] = event.target.checked;
    setTerms(newTerms);
  }

  return (
    <div className={style.termsContainer}>
      <p className={style.termsTitle}>Termeni si conditii</p>
      <FormControlLabel
        control={
          <Checkbox
            name="t1"
            checked={terms.t1}
            onChange={(e) => onChangeTerms(e)}
            style={{ margin: "10px" }}
          />
        }
        label="
      Cunoscând dispoziţiile Art. 326 Cod penal privind falsul în declaraţii,
      declar pe propria răspundere următoarele: toate datele și informațiile
      completate, sunt complete, reale și corecte."
      />
      <br />
      <br />
      <FormControlLabel
        control={
          <Checkbox
            name="t2"
            checked={terms.t2}
            onChange={(e) => onChangeTerms(e)}
            style={{ margin: "10px" }}
          />
        }
        label="
      Prin completarea acestui formular îmi exprim acordul cu privire la
      utilizarea şi prelucrarea datelor mele cu caracter personal de către
      Primaria municipiului Suceava , conform Regulamentului (UE) 679 / 2016
      privind protecția persoanelor fizice în ceea ce privește prelucrarea
      datelor cu caracter personal și privind libera circulație a acestor date,
      cu modificările şi completările ulterioare."
      />
      <br />
      <div className={style.termsBtn}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!(terms.t1 && terms.t2)}
        >
          Finalizează
        </Button>
      </div>
    </div>
  );
}

export default Terms;
Terms.propTypes = {
  handleSubmit: PropTypes.func,
};
